(function($) {

	'use strict';

	var init = function() {

		manageMenu();

		togglePhone();

		topOfPage();

	};

	var topOfPage = function() {
		$('.footer-menu__top').click(function() {
			$('html, body').animate({scrollTop: 0}, "slow");
			return false;
		})
	}

	var togglePhone = function() {		
		$('.header__social__icon--phone, .header__contact__phone').click(function() {
			$('.header__social__phone').toggleClass('header__social__phone--active');
			$('.header__contact__phone').toggleClass('active');
			$('.header__contact__phone__overlay').toggleClass('active');
			$('body').toggleClass('blurred')
		});
	}

	var manageMenu = function() {

		var delta = 2;

		if($('body').hasClass('home')) {
			delta = 1;
		}
		
		$('.header__button').click(function() {
			$(this).toggleClass('active');
			$('body').toggleClass('open');
			$('.header__menu').toggleClass('active');
		});

		$(window).resize(function() {
			if($(window).width() < 975) {
		
				var $expandItems = $('.menu-item-has-children');
		
				$expandItems.each(function() {
					var initial = $(this).find('.sub-menu').height();
					var expand = $(this).find('.sub-menu').prop('scrollHeight');
					var $item = $(this);
					$(this).click(function() {
						$item.toggleClass('active');
						$item.find('.sub-menu').toggleClass('active');
						if($item.find('.sub-menu').hasClass('active')) {
							$item.find('.sub-menu').css('max-height', expand + 'px');
						} else {
							$item.find('.sub-menu').css('max-height', initial + 'px');
						}
					});
				});
				
				$('.sub-menu > li').click(function(e) {
					e.stopPropagation();
				});
			} else {
				$('.sub-menu').css('max-height', 'auto');
			}
		});

		
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
